import { Box, Button, CircularProgress, Stack } from "@mui/material";
import React from "react";
import { PresignFileType } from "../../../../services/api/types/portalConfiguration/uploadPhoto";
import { FormErrors, FormValues } from "../AssignmentUploads";
import { UploadFile } from "./UploadFile";
import { VersionDetails, VersionField } from "./VersionDetails";
import { brand } from "../../../../theme/themePrimitives";

interface UploadSectionProps {
  setShowUploadSection: React.Dispatch<React.SetStateAction<boolean>>;
  formValues: FormValues;
  errors: FormErrors;
  handleFileUpload: (file: File | null, type: PresignFileType) => void;
  onVersionChange: (field: VersionField, value: string) => void;
  loading: boolean;
  buttonLoading: boolean;
  handleSave: () => void;
}

export const UploadSection: React.FC<UploadSectionProps> = ({
  setShowUploadSection,
  formValues,
  errors,
  handleFileUpload,
  onVersionChange,
  loading,
  buttonLoading,
  handleSave,
}) => {
  return (
    <Box>
      <Stack spacing={2}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "500px",
            }}
          >
            <CircularProgress size={100} />
          </Box>
        ) : (
          <>
            <Box>
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: `${brand[600]} !important`,
                  color: `white`,
                }}
                onClick={() => setShowUploadSection(false)}
              >
                Back
              </Button>
            </Box>
            <Box width={"100%"}>
              <UploadFile
                value={formValues.packageFile}
                onChange={(file) =>
                  handleFileUpload(file, PresignFileType.PACKAGE)
                }
                error={errors.packageFile}
                label="Upload package"
                mode="package"
                packageType={formValues.packageType}
              />
            </Box>
            <Box width={"100%"}>
              <VersionDetails
                version={formValues.version}
                note={formValues.note}
                onChange={onVersionChange}
                versionError={errors.version}
                noteError={errors.note}
              />
            </Box>
            <Box width={"100%"}>
              <UploadFile
                value={formValues.thumbnailFile}
                onChange={(file) =>
                  handleFileUpload(file, PresignFileType.PACKAGE_THUMBNAIL)
                }
                error={errors.thumbnailFile}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {buttonLoading ? (
                <CircularProgress />
              ) : (
                <Button
                  variant="outlined"
                  sx={{
                    backgroundColor: `${brand[600]} !important`,
                    color: `white`,
                    "&:hover": {
                      backgroundColor: `${brand[700]} !important`,
                    },
                  }}
                  onClick={handleSave}
                >
                  Save assignment
                </Button>
              )}
            </Box>
          </>
        )}
      </Stack>
    </Box>
  );
};
